import { SagaIterator } from 'redux-saga';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { CheckoutProdukt, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { RsVermieterActions } from '../rs-vermietung-actions.service';
import { IAppState } from '../appState';

export function* watchInDashboardUebernehmenSaga(): SagaIterator {
  yield takeEvery(
    RsVermieterActions.ABSPRUNG_INS_DASHBOARD,
    safeSaga(generateDashboardData, App.RS_VERMIETUNG),
  );
  yield takeEvery(
    RsVermieterActions.ABSPRUNG_INS_DASHBOARD,
    safeSaga(generateProduktData, App.RS_VERMIETUNG),
  );
}

export function* generateProduktData(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();
  const isAuslaendischeAdresse = state.vermieteteCardObjekte.some(c => c.auslaendischeAdresse);
  const produktData: CheckoutProdukt = {
    appId: App.RS_VERMIETUNG,
    laufzeit: state.vertragsoptionen.vertragslaufzeit,
    uebersichtTitle: 'Rechtsschutzversicherung Vermietung',
    versichertesRisiko: getVersichertesRisiko(state),
    vorvertragsnummer: state.vertragsoptionen.vorvertragsNummern,
    vorvertragSofortschutz: state.vertragsoptionen.vorvertragSofortschutz,
    beginndatum: state.vertragsoptionen.beginnDatum,
    isImmobilieImAusland: isAuslaendischeAdresse,
    angebotsdatum: state.vertragsoptionen.angebotsdatum,
  };
  yield call([globalPut, globalPut.put], new GlobalActions().produktAction(produktData));
}

export function* generateDashboardData(): SagaIterator {
  const state = yield select();
  const globalPut = GlobalPut.getInstance();
  const selectedProduktlinie: Produktlinie = getSelectedProduktlinie(state.produkt);
  yield put(new RsVermieterActions().vorschlagdatenChanged());
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().inDashboardUebernehmen({
      appId: App.RS_VERMIETUNG,
      kurztext: selectedProduktlinie.kurztext,
      ausgewaehlteLinie: selectedProduktlinie.produktName,
      versichertesRisiko: getVersichertesRisiko(state),
      vertragslaufzeit: state.vertragsoptionen.vertragslaufzeit,
      selectZusatzoptionen: [],
      beginn: state.vertragsoptionen.beginnDatum,
    }),
  );
}

export function getVersichertesRisiko(state: IAppState): string {
  return state.vermieteteCardObjekte
    .map(
      versObjekt =>
        `${versObjekt.plz} ${versObjekt.ort}, ${versObjekt.strasse} ${versObjekt.hausnummer?.length > 0 ? versObjekt.hausnummer : ''}`,
    )
    .join('<br>')
    .trim();
}
